export const capitaliseFirstLetter = (word: string) => word.charAt(0).toUpperCase() + word.slice(1)

export const splitOnCapitals = (string: string) =>
  string
    .match(/([A-Z]?[^A-Z]*)/g)
    .slice(0, -1)
    .join(' ')

export const sentenceCase = (string: string) =>
  capitaliseFirstLetter(splitOnCapitals(string).toLowerCase())

export const isUpperCase = (string: string) => string === string.toUpperCase()

export const unformatNumberString = (string: string) => {
  if (!string) return 0
  return Number(string.replaceAll(/[^\d|.]/g, ''))
}
